import React from 'react';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
export default function DetailSearchBtn(_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React.createElement("div", { className: "flex-layout-center-h", style: {
            lineHeight: '36px',
            height: '36px',
        } },
        React.createElement("div", { className: "color-primary flex-layout-center-h", style: {
                fontSize: 12,
                cursor: 'pointer',
                color: '#666666',
            }, onClick: onClick },
            text,
            "\u00A0",
            React.createElement("img", { src: arrowRightIcon, alt: "" }))));
}
//# sourceMappingURL=DeatilSearchBtn.js.map